import { Box, Button, Typography, useTheme } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
// import { mockDataTeam } from "../../data/mockData";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header";
import EditIcon from '@mui/icons-material/Edit';
// import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Link } from 'react-router-dom';


const Team = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const columns = [
        { field: "id", headerName: "ID" },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "age",
            headerName: "Age",
            type: "number",
            headerAlign: "left",
            align: "left",
        },
        {
            field: "phone",
            headerName: "Phone Number",
            flex: 1,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
        },
        {
            field: "accessLevel",
            headerName: "Access Level",
            flex: 1,
            renderCell: ({ row: { access } }) => {
                return (
                    <Box
                        width="60%"
                        m="0 auto"
                        p="5px"
                        display="flex"
                        justifyContent="center"
                        backgroundColor={
                            access === "admin"
                                ? colors.greenAccent[600]
                                : access === "manager"
                                    ? colors.greenAccent[700]
                                    : colors.greenAccent[700]
                        }
                        borderRadius="4px"
                    >
                        {access === "admin" && <AdminPanelSettingsOutlinedIcon />}
                        {access === "manager" && <SecurityOutlinedIcon />}
                        {access === "user" && <LockOpenOutlinedIcon />}
                        <Typography color={colors.grey[100]} sx={{ ml: "5px" }}>
                            {access}
                        </Typography>
                    </Box>
                );
            },
        },
    ];

    return (
        <Box m="20px">
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="VISA MANAGEMENT" subtitle="Visa Management List" />

                <Box>
                    <Button
                        sx={{
                            backgroundColor: colors.blueAccent[700],
                            color: colors.grey[100],
                            fontSize: "14px",
                            fontWeight: "bold",
                            padding: "10px 20px",
                        }}
                    >
                        <Link to="/createvisaprocessing" className="text-decoration-none text-white">
                            + Add New Visa Management
                        </Link>
                    </Button>
                </Box>
            </Box>
            <Box
                m="40px 0 0 0"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                }}
            >
                {/* <DataGrid checkboxSelection rows={mockDataTeam} columns={columns} /> */}
                <div class="table-responsive">
                    <table class="table accordion table-dark">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Name</th>
                                <th scope="col">Agent Name</th>
                                <th scope="col">Visa Fee</th>
                                <th scope="col">Service Charge</th>
                                <th scope="col">Paid Amount</th>
                                <th scope="col">Due Amount</th>
                                <th scope="col">Visa Type</th>
                                <th scope="col">Visa for Country</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr data-bs-toggle="collapse" data-bs-target="#r1">
                                <th scope="row">+</th>
                                <td>nazmul hasan</td>
                                <td>REAL JOURNEY</td>
                                <td>5000.00</td>
                                <td>500.00</td>
                                <td>500.00</td>
                                <td>500.00</td>
                                <td>ABC</td>
                                <td>Singapre</td>
                            </tr>
                            <tr class="collapse accordion-collapse" id="r1" data-bs-parent=".table">
                                <td colspan="9">
                                    <b> Passport Number:</b> 1245826462<br />
                                    <b> Father's Name:</b> 1245826462<br />
                                    <b> Mother's Name:</b> 1245826462<br />
                                    <b> Date of Birth:</b> 1245826462<br />
                                    <b> Date:</b> 1245826462<br />
                                    <b> Issue date:</b> 1245826462<br />
                                    <b> Expired date:</b> 1245826462<br />
                                    <b> Address:</b> 1245826462<br />
                                    <b> Remarks:</b> 1245826462<br />
                                    <b>Action:</b>
                                </td>
                            </tr>
                            <tr data-bs-toggle="collapse" data-bs-target="#r2">
                                <th scope="row">+</th>
                                <td>nazmul hasan</td>
                                <td>REAL JOURNEY</td>
                                <td>5000.00</td>
                                <td>500.00</td>
                                <td>500.00</td>
                                <td>500.00</td>
                                <td>ABC</td>
                                <td>Singapre</td>
                            </tr>
                            <tr class="collapse accordion-collapse" id="r2" data-bs-parent=".table">
                                <td colspan="9">
                                    <b> Passport Number:</b> 1245826462<br />
                                    <b> Father's Name:</b> 1245826462<br />
                                    <b> Mother's Name:</b> 1245826462<br />
                                    <b> Date of Birth:</b> 1245826462<br />
                                    <b> Date:</b> 1245826462<br />
                                    <b> Issue date:</b> 1245826462<br />
                                    <b> Expired date:</b> 1245826462<br />
                                    <b> Address:</b> 1245826462<br />
                                    <b> Remarks:</b> 1245826462<br />
                                    <b>Action:</b>
                                </td>
                            </tr>
                            <tr data-bs-toggle="collapse" data-bs-target="#r3">
                                <th scope="row">+</th>
                                <td>nazmul hasan</td>
                                <td>REAL JOURNEY</td>
                                <td>5000.00</td>
                                <td>500.00</td>
                                <td>500.00</td>
                                <td>500.00</td>
                                <td>ABC</td>
                                <td>Singapre</td>
                            </tr>
                            <tr class="collapse accordion-collapse" id="r3" data-bs-parent=".table">
                                <td colspan="9">
                                    <b> Passport Number:</b> 1245826462<br />
                                    <b> Father's Name:</b> 1245826462<br />
                                    <b> Mother's Name:</b> 1245826462<br />
                                    <b> Date of Birth:</b> 1245826462<br />
                                    <b> Date:</b> 1245826462<br />
                                    <b> Issue date:</b> 1245826462<br />
                                    <b> Expired date:</b> 1245826462<br />
                                    <b> Address:</b> 1245826462<br />
                                    <b> Remarks:</b> 1245826462<br />
                                    <b>Action:</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Box>
        </Box>
    );
};

export default Team;
